import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const sentryEnv = import.meta.env.VITE_SENTRY_ENV ?? "local";

if (typeof window !== "undefined" && window.location.hostname !== "localhost") {
  Sentry.init({
    dsn: "https://f5039cb23f8756bd1d2953507b1dd43e@o4507902607818752.ingest.us.sentry.io/4507934474633216",
    environment: sentryEnv,
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ["claimable-console"],
        behaviour: "drop-error-if-contains-third-party-frames",
      }),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false,
        mask: ["input", "textarea", "select", "[data-sentry-mask]"],
        block: ["[data-sentry-block]"],
        ignore: ["[data-sentry-ignore]"],
      }),
      Sentry.browserProfilingIntegration(),
      Sentry.captureConsoleIntegration(),
      Sentry.extraErrorDataIntegration(),
    ],
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    tracePropagationTargets: [
      /^https:\/\/.*\.execute-api\.us-east-1\.amazonaws\.com/,
      /^https:\/\/.*\.preclaimable\.com/,
    ],
  });
}
